import { render } from "./InstagramInsights.vue?vue&type=template&id=21cf1c6c&scoped=true"
import script from "./InstagramInsights.vue?vue&type=script&lang=js"
export * from "./InstagramInsights.vue?vue&type=script&lang=js"

import "./InstagramInsights.vue?vue&type=style&index=0&id=21cf1c6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cf1c6c"]])

export default __exports__